export enum TranslationStatusEnum {
    NOT_READY = 'not_ready',
    WAITING = 'waiting',
    NEED_CHECK = 'need_check',
    READY = 'ready',
    SKIPPER = 'skipped',
}
